import { IoIosArrowRoundForward } from 'react-icons/io';
import ImageWithFallback from '../shared/ImageWithFallback';
import { stableCoins } from './stableCoins';
export default function CashResults({
  setCashModalData
}) {
  return <div className='mt-2' data-sentry-component="CashResults" data-sentry-source-file="CashResult.tsx">
      {stableCoins?.map((searchResult, index) => {
      return <div key={`${searchResult.name}-${index}`} className={`flex px-4 h-[80px] w-full justify-between items-center hover:cursor-pointer md:hover:bg-genius-blue ${searchResult.name === 'usdc' && 'gradient-genius-sides'}`} onClick={() => setCashModalData(searchResult)}>
            <div className='flex items-center gap-3 relative'>
              <ImageWithFallback src={`/static/tokenlogos/${searchResult.name}.png`} width={24} height={24} alt='token-logo' className='rounded-full tokenImg' />

              <div className='flex flex-col justify-start text-left'>
                <p className='text-base/4 text-genius-cream'>{searchResult.name.toUpperCase()}</p>
                <p className='text-[12px] text-genius-cream/70 flex items-center font-light'>
                  Details <IoIosArrowRoundForward className='w-[16px] h-[16px]' />
                </p>
              </div>
              {searchResult.name === 'usdc' && <div className='bg-black text-[10px] text-genius-cream rounded-full p-1 px-2'>
                  Recommended
                </div>}
            </div>
            <div className='flex flex-col text-right max-w-18 text-wrap'>
              <p className='text-base/4 text-genius-cream text-right text-wrap'>$1.0</p>
              <div className='flex gap-1 items-center justify-end text-right text-genius-cream/50 text-[12px] font-light'>
                Stable
              </div>
            </div>
          </div>;
    })}
    </div>;
}